import { FormEvent, useCallback, useState } from 'react';
import useInput from '../hooks/useInput';
import { Props, sendMessage } from '../slack/app';
import { Group, MainStyle, Spinner, Submit } from '../styles/style';
import Logo from '../assets/cambee-partners-form-logo.png';
import { storage } from '../config/firebase';
import { ref, getDownloadURL, uploadBytes } from 'firebase/storage';
import ClipLoader from 'react-spinners/ClipLoader';

const url = process.env.REACT_APP_SLACK;

function Main() {
  const [company, onChangeCompany] = useInput('');
  const [companyNumber, onChangeCompanyNumber] = useInput('');
  const [companyAddress, onChangeCompanyAddress] = useInput('');
  const [managerName, onChangeManagerName] = useInput('');
  const [managerNumber, onChangeManagerNumber] = useInput('');
  const [managerEmail, onChangeManagerEmail] = useInput('');
  const [brandName, onChangeBrandName] = useInput('');
  const [salesChannel, onChangeSalesChannel] = useInput('');
  const [checkedList, setCheckedList] = useState<Array<string>>([]);
  const [file1, setFile1] = useState('');
  const [file2, setFile2] = useState('');
  const [file1Name, setFile1Name] = useState('');
  const [file2Name, setFile2Name] = useState('');
  const [isAgree, setIsAgree] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      if (!isAgree) alert('개인정보 수집 및 이용에 동의하셔야 합니다');
      else {
        const obj: Props = {
          company,
          companyNumber,
          companyAddress,
          managerName,
          managerNumber,
          managerEmail,
          brandName,
          salesChannel,
          checkedList,
          file1,
          file2,
        };

        setIsLoading(true);
        sendMessage(obj, url)
          .then((res) => {
            console.log(res);
            setIsLoading(false);

            if (res === 'ok') {
              alert('입점신청서 제출이 완료되었습니다!');
              window.location.href = 'https://cambee.co.kr';
            }
          })
          .catch((error) => {
            alert(error + '전송에 실패했습니다');
            setIsLoading(false);
          });
      }
    },
    [
      isAgree,
      company,
      companyNumber,
      companyAddress,
      managerName,
      managerNumber,
      managerEmail,
      brandName,
      salesChannel,
      checkedList,
      file1,
      file2,
    ]
  );

  const categoryList = [
    { name: '캠핑기어' },
    { name: '취사용품' },
    { name: '침구·수면용품' },
    { name: '꾸미기·소품' },
    { name: '포터블가전' },
    { name: '아이디어상품' },
    { name: '밀키트·간편식' },
    { name: '장작' },
    { name: '주류' },
    { name: '기타 소모품' },
  ];

  const onClickIsAgree = useCallback(() => {
    if (isAgree) setIsAgree(0);
    else setIsAgree(1);
  }, [isAgree]);

  const onCheckedItem = useCallback(
    (checked: boolean, item: string) => {
      if (checked) {
        setCheckedList((prev) => [...prev, item]);
      } else if (!checked) {
        setCheckedList(checkedList.filter((el) => el !== item));
      }
    },
    [checkedList]
  );

  const onChangeFile1 = useCallback((e: any) => {
    const file = e.target.files[0];
    const fileName = `${file.lastModified}_${file.name}`;

    if (!file) return;
    const storageRef = ref(storage, fileName);
    setIsLoading(true);

    uploadBytes(storageRef, file)
      .then(() => {
        getDownloadURL(ref(storage, fileName))
          .then((url) => {
            setFile1Name(file.name);
            setIsLoading(false);
            setFile1(url);
          })
          .catch((error) => {
            setIsLoading(false);
            alert(`${error} 파일 업로드에 실패하였습니다!`);
          });
      })
      .catch((error) => {
        setIsLoading(false);
        alert(`${error} 파일 업로드에 실패하였습니다`);
      });
  }, []);

  const onChangeFile2 = useCallback((e: any) => {
    const file = e.target.files[0];
    const fileName = `${file.lastModified}_${file.name}`;

    if (!file) return;
    const storageRef = ref(storage, fileName);
    setIsLoading(true);

    uploadBytes(storageRef, file)
      .then(() => {
        getDownloadURL(ref(storage, fileName))
          .then((url) => {
            setFile2Name(file.name);
            setIsLoading(false);
            setFile2(url);
          })
          .catch((error) => {
            setIsLoading(false);
            alert(`${error} 파일 업로드에 실패하였습니다!`);
          });
      })
      .catch((error) => {
        setIsLoading(false);
        alert(`${error} 파일 업로드에 실패하였습니다`);
      });
  }, []);

  return (
    <MainStyle>
      <Group>
        <h1>
          <img src={Logo} alt='캠비 입점폼 로고' />
        </h1>
        <ul>
          <li>👉 작성해주신 정보를 바탕으로 입점담당자 검토 후 이메일을 전달해드리고 있습니다</li>
          <li>👉 입점신청 후 최종승인까지 평균 3~5 영업일이 소요되는점 참고 부탁드립니다</li>
          <li>👉 기재해주신 담당자님 전화 및 이메일로 진행사항이 전달되니 정확한 정보 입력 부탁드립니다</li>
          <li>
            👉 입점관련 기타 문의사항이 있으시다면 <a href='mailto:partners@cambee.co.kr'>partners@cambee.co.kr</a> 으로
            전달 부탁드립니다
          </li>
        </ul>
      </Group>

      <form onSubmit={onSubmit}>
        <Group>
          <div className='item'>
            <h2 className='title'>입점사 정보</h2>
            <div className='inputgroup'>
              <label htmlFor='companyName'>사업자명</label>
              <input
                type='text'
                id='companyName'
                value={company}
                onChange={onChangeCompany}
                required
                placeholder='사업자명'
              />
            </div>
            <div className='inputgroup'>
              <label htmlFor='companyNumber'>사업자등록번호</label>
              <input
                type='text'
                id='companyNumber'
                value={companyNumber}
                onChange={onChangeCompanyNumber}
                required
                placeholder='사업자등록번호'
              />
            </div>
            <div className='inputgroup page'>
              <label htmlFor='companyAddress'>홈페이지</label>
              <input
                type='text'
                id='companyAddress'
                value={companyAddress}
                onChange={onChangeCompanyAddress}
                placeholder='홈페이지'
              />
            </div>
          </div>

          <div className='border'></div>

          <div className='item'>
            <h2 className='title'>영업담당자 정보</h2>
            <div className='inputgroup'>
              <label htmlFor='managerName'>성함</label>
              <input
                type='text'
                id='managerName'
                value={managerName}
                onChange={onChangeManagerName}
                required
                placeholder='담당자님 성함'
              />
            </div>
            <div className='inputgroup'>
              <label htmlFor='managerNumber'>전화번호</label>
              <input
                type='text'
                inputMode='numeric'
                id='managerNumber'
                value={managerNumber}
                onChange={onChangeManagerNumber}
                required
                placeholder='영업담당자 전화번호'
              />
            </div>
            <div className='inputgroup'>
              <label htmlFor='managerEmail'>이메일</label>
              <input
                type='text'
                id='managerEmail'
                value={managerEmail}
                onChange={onChangeManagerEmail}
                required
                placeholder='영업담당자 이메일'
              />
            </div>
          </div>
        </Group>
        <Group>
          <div className='item category'>
            <h2 className='title'>상품정보</h2>
            <div className='inputgroup'>
              <label htmlFor='brandName'>판매브랜드</label>
              <input
                type='text'
                id='brandName'
                value={brandName}
                onChange={onChangeBrandName}
                required
                placeholder='취급하시는 브랜드를 모두 입력해주세요'
              />
            </div>
            <div className='inputgroup'>
              <label htmlFor='salesChannel'>기존 판매채널</label>
              <input
                type='text'
                id='salesChannel'
                value={salesChannel}
                onChange={onChangeSalesChannel}
                required
                placeholder='쿠팡, 네이버스토어 등 판매중인 채널을 입력해주세요'
              />
            </div>
            <div className='inputgroup category'>
              <label htmlFor=''>상품 카테고리</label>
              <div className='list'>
                {categoryList.map((item) => {
                  return (
                    <label className='checkboxLabel' key={item.name}>
                      <input
                        type='checkbox'
                        id={item.name}
                        onChange={(e) => {
                          onCheckedItem(e.target.checked, e.target.id);
                        }}
                      />
                      <label htmlFor={item.name}>
                        <span></span>
                        {item.name}
                      </label>
                    </label>
                  );
                })}
              </div>
            </div>
          </div>
        </Group>
        <Group>
          <div className='item'>
            <h2 className='title'>입점서류 제출</h2>

            <div className='inputgroup file'>
              <label htmlFor='file1'>사업자등록증</label>
              <div className='fileupload_group'>
                <input
                  className={file1 ? 'upload-name gray' : 'upload-name'}
                  value={file1Name}
                  placeholder='파일을 업로드해주세요'
                  readOnly
                />
                <input type='file' id='file1' onChange={onChangeFile1} defaultValue={file1} required />
                <label className={file1 ? 'filebutton gray' : 'filebutton'} htmlFor='file1'>
                  {file1 ? '수정하기' : '첨부하기'}
                </label>
              </div>
            </div>

            <div className='inputgroup file'>
              <label htmlFor='file2'>통신판매업 신고증</label>
              <div className='fileupload_group'>
                <input
                  className={file2 ? 'upload-name gray' : 'upload-name'}
                  value={file2Name}
                  placeholder='파일을 업로드해주세요'
                  readOnly
                />
                <input type='file' id='file2' onChange={onChangeFile2} defaultValue={file2} required />
                <label className={file2 ? 'filebutton gray' : 'filebutton'} htmlFor='file2'>
                  {file2 ? '수정하기' : '첨부하기'}
                </label>
              </div>
            </div>
          </div>
        </Group>

        <Submit>
          <div className='container'>
            <label className='checkboxLabel'>
              <input type='checkbox' value={isAgree} onClick={onClickIsAgree} id='agree' />
              <label htmlFor='agree'>
                <span></span>
                개인정보 수집 및 이용에 동의합니다 <strong>(필수)</strong>
              </label>
            </label>

            <button className={isLoading ? 'loading' : undefined}>신청서 제출하기</button>
          </div>
          <Spinner>
            <ClipLoader color='#8cb38d' loading={isLoading} size={50} />
          </Spinner>
        </Submit>
      </form>
    </MainStyle>
  );
}

export default Main;
